import history from '../../util/history'

const onCancelCreation = () => {
  history.goBack()
}

export default onCancelCreation
